// extracted by mini-css-extract-plugin
module.exports = {"load":"loading_load__Ml_Kc"};